<template>
  <div :class="type" class="app-float">
    <a v-if="state.floatEventEntry?.jumpLink" class="event-enrty" :href="state.floatEventEntry?.jumpLink" target="_blank" :class="locale">
      <img class="event-enrty-img" :src="state.floatEventEntry?.entryImageUrl" alt="img">
    </a>
    <div class="custom" @click="handleCustom"></div>
    <div class="top" @click="handleTop"></div>
    <Dialog v-model="customeDialog.visible" :cancelText="customeDialog.cancelText">
      <div class="dialog-content">
        {{ $t('customerServiceText') }}
      </div>
    </Dialog>
    <PopupEventAnnDialog :data="state.popupEventEntry" />
  </div>
</template>

<script setup>
import { reactive, computed, nextTick, watch } from 'vue'
import { isMobile, loadScript } from '@/utils'
import { loadingService } from '@/utils/loadingService'
import { aihelpLangOptions } from '@/config/lang'
import Dialog from '@/views/payment/components/Dialog/index.vue'
import PopupEventAnnDialog from '@/components/Dialog/PopupEventAnn/index.vue'
import { useI18n } from 'vue-i18n'
import { useLog } from '@/composables/useLog'
import Api from '@/config/api'
const { locale } = useI18n()
const log = useLog()
const { t } = useI18n()
const type = isMobile ? 'mobile' : 'pc'
// const eventEntryUrl = computed(() => {
//   return `${process.env.VUE_APP_HISTORY_URL}${locale.value}/sf`
// })

const state = reactive({
  eventEntryList: [],
  floatEventEntry: computed(() => { // 浮窗活动入口
    return state.eventEntryList.find(item => item.entryType === 1)
  }),
  popupEventEntry: computed(() => { // 拍脸活动入口
    return state.eventEntryList.find(item => item.entryType === 2)
  }),
})

const customeDialog = reactive({
  visible: false,
  cancelText: computed(() => t('cancelText'))
})

const handleCustom = async () => {
  const aihelpLang = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
  if (!window.AIHelpSupport) {
    await loadScript('https://cdn.aihelp.net/webchatv5/aihelp.js')
  }
  const initConfig = {
    domain: 'miniwantechnologycolimited.aihelp.net',
    appId: 'miniwantechnologycolimited_platform_36bbfccee53e93eeaa51b18afe074c83',
    language: aihelpLang
  }
  console.log('locale.value', locale.value)
  const unwatch = watch(locale, () => {
    if (window.AIHelpSupport) {
      const language = aihelpLangOptions.find(item => item.appLang === locale.value)?.aihelpLang || 'en'
      window.AIHelpSupport.updateSDKLanguage(language)
    }
  })
  nextTick(() => {
    loadingService.show()
    window.AIHelpSupport.initialize(initConfig)
    window.AIHelpSupport.registerAsyncEventListener("initialization", function (jsonData) {
      console.log('jsonData', jsonData)
      if (jsonData.isSuccess) {
        window.AIHelpSupport.show("webrecharge")
        loadingService.hide()
      }
    })
    window.AIHelpSupport.registerAsyncEventListener("sessionClose", function () {
      unwatch()
    })
  })
  log.track('payment_help_click', {})
  // customeDialog.visible = true
}
const handleTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

const getRechargeEntryList = async () => {
  const res = await Api.getRechargeEntryList()
  console.log('res', res)
  state.eventEntryList = res?.entrys || []
}
getRechargeEntryList()
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
